import { IInputIntProps } from '@root-gipro/modules/userProjects/models/interfaces/project.props'
import { formatedDeflatorValue, lightPretty } from '@root-gipro/utils/helpers/common'
import React, { RefObject, useEffect, useRef, useState } from 'react'

const InputInt: React.FC<IInputIntProps> = ({
	inputName,
	value,
	changeFunc,
	placeholder,
	disabled,
	precision,
	inputRef,
	setFocusPosition,
}) => {
	const [localValue, setLocalValue] = useState<string>('')
	const [isFocused, setIsFocused] = useState(false)
	const selectionRef = useRef<number | null>(null)

	useEffect(() => {
		if (!isFocused) {
			if (value !== undefined && value !== null && value !== '') {
				const strVal = String(value).replace(/\s/g, '')
				const withPrecision = formatedDeflatorValue(strVal, precision)
				const pretty = lightPretty(withPrecision)
				setLocalValue(pretty)
			} else {
				setLocalValue('')
			}
		}
	}, [value, precision, isFocused])

	useEffect(() => {
		const ref = inputRef as RefObject<HTMLInputElement>
		if (ref?.current && selectionRef.current !== null) {
			ref.current.setSelectionRange(selectionRef.current, selectionRef.current)
		}
	}, [localValue])

	const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
		setIsFocused(true)
		const raw = e.currentTarget.value.replace(/\s/g, '')
		setLocalValue(raw)
	}

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const cursorPosition = e.currentTarget.selectionStart || 0
		const raw = e.currentTarget.value.replace(/\s/g, '')

		if (!/^\d*(\.\d*)?$/.test(raw)) return

		selectionRef.current = cursorPosition
		setLocalValue(raw)
		changeFunc?.(raw)
	}

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		setIsFocused(false)
		const raw = e.currentTarget.value.replace(/\s/g, '')

		if (!raw || !/^\d*(\.\d+)?$/.test(raw)) {
			setLocalValue('')
			changeFunc?.('')
			return
		}

		const withPrecision = formatedDeflatorValue(raw, precision)
		const pretty = lightPretty(withPrecision)
		setLocalValue(pretty)
		changeFunc?.(withPrecision)
	}

	return (
		<input
			id={inputName}
			name={inputName}
			ref={inputRef as RefObject<HTMLInputElement>}
			value={localValue}
			onFocus={handleFocus}
			onChange={handleChange}
			onBlur={handleBlur}
			placeholder={placeholder}
			disabled={disabled}
			className='universal-input'
			type='text'
			autoComplete='off'
		/>
	)
}

export { InputInt }
